import { Image } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import { FC } from 'react';
import chevronForward from 'assets/img/icons/chevron-forward.svg';

interface Props {
  logo: string;
  onClick: () => void;
}

const SelectBrokerItem: FC<Props> = ({ logo, onClick }) => {
  return (
    <AppCard
      onClick={onClick}
      p="40px"
      display="flex"
      alignItems="center"
      cursor="pointer"
      justifyContent="space-between"
    >
      <Image src={logo} width={logo.includes('armenia') || logo.includes('global') ? '230px' : '200px'}/>
      <Image src={chevronForward} h="20px" />
    </AppCard>
  );
};

export default SelectBrokerItem;
